export default {
	UPDATE_CONTENT_HEIGHT: "UPDATE_CONTENT_HEIGHT",
	UPDATE_CURRENT_REGNO: "UPDATE_CURRENT_REGNO",
	UPDATE_DATA: "UPDATE_DATA",
	ADD_SO: "ADD_SO",
	SHOW_SO_MODAL: "SHOW_SO_MODAL",
	SHOW_SO_EDIT_MODAL: "SHOW_SO_EDIT_MODAL",
	HIDE_SO_MODAL: "HIDE_SO_MODAL",
	START_SO_MODAL_LOADING: "START_SO_MODAL_LOADING",
	STOP_SO_MODAL_LOADING: "STOP_SO_MODAL_LOADING",
	UPDATE_REG_NO_INPUT: "UPDATE_REG_NO_INPUT",
	UPDATE_SO_NO_TEXTAREA: "UPDATE_SO_NO_TEXTAREA",
	UPDATE_SO_MODAL_MESSAGE: "UPDATE_SO_MODAL_MESSAGE",
	START_QUERY_LOADING: "START_QUERY_LOADING",
	STOP_QUERY_LOADING: "STOP_QUERY_LOADING",
	UPDATE_REG_DATA: "UPDATE_REG_DATA",
	REMOVE_REG: "REMOVE_REG",
	SHOW_CONT_MODAL: "SHOW_CONT_MODAL",
	HIDE_CONT_MODAL: "HIDE_CONT_MODAL",
}



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js